import MenuNotificaciones from "./MenuNotificaciones"
import MonitorNotificaciones from "./MonitorNotificaciones";
import Admin from "./admin/Admin";
import TipoNotificaciones from "./admin/TipoNotificaciones";
import TipoColaborador from "./admin/TipoColaborador"
import SegmentoNotificacion from "./admin/SegmentoNotificacion";

const ModuloNotificacionesRouter = [
  {
    type: "private",
    path: "/conf-notificaciones/menu",
    roles: ["administrador"],
    component: MenuNotificaciones,
    exact: true,
  },
  {
    type: "private",
    path: "/conf-notificaciones/monitor/:module",
    roles: ["administrador", "Responsable_Capacitacion", "Responsable_Carrera", "Responsable_Carrera_Sucesion", "Responsable_Descriptores_Perfiles", "responsable_desempeno_laboral", "Responsable_Evaluacion", "Responsable_Headcount", "Responsable_OffBoarding", "Responsable_OnBoarding", "Responsable_Sanciones", "Responsable_Seleccion_Contratacion", "Encargado_Sanciones" ],
    component: MonitorNotificaciones,
    exact: true
  },
  {
    type: "private",
    path: "/conf-notificaciones/admin",
    roles: ["administrador"],
    component: Admin,
    exact: true
  },
  /* {
    type: "private",
    path: "/conf-notificaciones/admin/tipo-notificacion",
    roles: ["administrador", "Responsable_Notificaciones"],
    component: TipoNotificaciones,
    exact: true,
  },
  {
    type: "private",
    path: "/conf-notificaciones/admin/tipo-colaborador",
    roles: ["administrador", "Responsable_Notificaciones"],
    component: TipoColaborador,
    exact: true,
  }, */
  {
    type: "private",
    path: "/conf-notificaciones/admin/segmento",
    roles: ["administrador"],
    component: SegmentoNotificacion,
    exact: true,
  },




];

export default ModuloNotificacionesRouter;
